import { render, staticRenderFns } from "./navigator.vue?vue&type=template&id=03c0e50a&scoped=true"
import script from "./navigator.vue?vue&type=script&lang=js"
export * from "./navigator.vue?vue&type=script&lang=js"
import style0 from "./navigator.vue?vue&type=style&index=0&id=03c0e50a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c0e50a",
  null
  
)

export default component.exports